import MailtemplateIndex from "../../src/components/settings/pages/mailtemplates/index";
import MailtemplateEdit from "../../src/components/settings/pages/mailtemplates/edit";
import createCommittee from "../../src/components/settings/pages/committee";
import createGroup from "../../src/components/settings/pages/group";
import subscriptions from "../../src/components/settings/pages/subscriptions";
import itemgroups from "../../src/components/settings/pages/itemgroups/list";
import itemtypes from "../../src/components/settings/pages/itemtypes/list";
import itemtypeForm from "../../src/components/settings/pages/itemtypes/itemtype_form";
import createEventType from "../../src/components/settings/pages/eventtype/create";
// import editEventType from "../../src/components/settings/pages/eventtype/edit";
import listEventType from "../../src/components/settings/pages/eventtype/list";

import listCommittees from "../../src/components/settings/pages/committees/list";
import editCommittee from "../../src/components/settings/pages/committees/edit";
import showItemgroups from "../../src/components/settings/pages/itemgroups/showItemgroups";

import listGroups from "../../src/components/settings/pages/groups/list";
import editGroup from "../../src/components/settings/pages/groups/edit";

import emailAddresses from "../../src/components/settings/pages/emailaddresses/index";
import createEmailAddress from "../../src/components/settings/pages/emailaddresses/create";
import editEmailAddress from "../../src/components/settings/pages/emailaddresses/edit";
import paymentProviderIndex from "../../src/components/settings/pages/payment/providers/index";
import paymentMethodIndex from "../../src/components/settings/pages/payment/methods/index";

import help from "../../src/components/settings/pages/help/index";
import editHelp from "../../src/components/settings/pages/help/edit";
import createHelp from "../../src/components/settings/pages/help/create";

export default [
  {
    path: "mailtemplates",
    component: MailtemplateIndex,
    meta: {
      permissions: ["Beheer Mailtemplates"],
    },
  },
  {
    path: "mailtemplates/:id",
    component: MailtemplateEdit,
  },
  {
    path: "payment-providers",
    component: paymentProviderIndex,
    meta: {
      permissions: ["Financieel"],
    },
  },
  {
    path: "payment-methods",
    component: paymentMethodIndex,
    meta: {
      permissions: ["Financieel"],
    },
  },
  {
    path: "subscriptions",
    component: subscriptions,
    meta: {
      permissions: ["Financieel"],
    },
  },
  {
    path: "itemgroups",
    component: itemgroups,
    meta: {
      permissions: ["Beheer Informatie"],
    },
  },
  {
    path: "itemgroups/:id/view",
    name: "settings.itemgroup",
    component: showItemgroups,
    meta: {
      permissions: ["Beheer Informatie"],
    },
  },
  {
    path: "itemtypes",
    component: itemtypes,
    meta: {
      permissions: ["Beheer Informatie"],
    },
  },

  {
    path: "itemtype/create",
    component: itemtypeForm,
    name: "create-itemtype",
    meta: {
      permissions: ["Beheer Informatie"],
    },
  },
  {
    path: "itemtype/:id/edit",
    component: itemtypeForm,
    name: "edit-itemtype",
    meta: {
      permissions: ["Beheer Informatie"],
    },
  },

  {
    path: "committees",
    component: listCommittees,
    meta: {
      permissions: ["Beheer Commissies"],
    },
  },
  {
    path: "community/settings",
    component: editCommittee,
    meta: {
      committee_id: 1,
      permissions: ["Beheer Informatie"],
    },
  },
  {
    path: "committee/:id",
    component: editCommittee,
  },
  {
    path: "create/committee",
    component: createCommittee,
    meta: {
      permissions: ["Beheer Groepen", "Beheer Commissies"],
    },
  },
  {
    path: "groups",
    component: listGroups,
    meta: {
      permissions: ["Beheer Groepen"],
    },
  },
  {
    path: "group/:id",
    component: editGroup,
  },
  {
    path: "create/group",
    component: createGroup,
    meta: {
      permissions: ["Beheer Groepen", "Beheer Commissies"],
    },
  },
  {
    path: "create/eventtype",
    component: createEventType,
  },
  {
    path: "edit/eventtype/:id",
    component: createEventType,
  },
  {
    path: "list/eventtypes",
    component: listEventType,
    meta: {
      permissions: ["Beheer Activiteiten"],
    },
  },
  {
    path: "emailaddresses",
    component: emailAddresses,
    name: "emailaddressesList",
    meta: {
      permissions: ["Beheer Emailadressen"],
    },
  },
  {
    path: "emailaddresses/create",
    component: createEmailAddress,
    meta: {
      permissions: ["Beheer Emailadressen"],
    },
  },
  {
    path: "emailaddresses/:id",
    component: editEmailAddress,
    meta: {
      permissions: ["Beheer Emailadressen"],
    },
  },
  {
    path: "help",
    component: help,
    name: "help",
    meta: {
      roles: ["Super-Admin"],
    },
  },
  {
    path: "help/:id",
    component: editHelp,
  },
  {
    path: "edit-help/:id",
    component: editHelp,
  },
  {
    path: "create-help",
    component: createHelp,
  },
];
